<template>
  <div class="search-container">
    <i class="ion ion-search-outline" @click="search"></i>
    <input
      v-model="searchText"
      type="text"
      class="search-container__searcher"
      placeholder="Search..."
      v-on:keyup.enter="search()"
    />
    <button
      v-show="searchText"
      class="search-container__delete-word"
      @click="clearSearchField"
    >
      X
    </button>
  </div>
</template>

<script>
export default {
  name: "SearchInsurance",
  data() {
    return {
      searchText: null,
    };
  },
  methods: {
    search() {
      this.$emit("insuranceSearch", this.searchText);
    },
    clearSearchField() {
      this.searchText = null;
      this.$emit('insuranceClearSearchField');
    }
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_mixin' as *;
.search-container {
  position: relative;
  display: flex;
  width: 30%;
  min-width: 240px;
  height: 40px;
  padding: 6px;
  border-radius: 15px;
  border: 1px solid $color-grey-border;
  background-color: $color-white;
  &__searcher {
    width: 100%;
    margin-left: 5px;
    padding-right: 15px;
    background-color: transparent;
    border: none;
    outline: none;
    text-align: left;
    font-family: $font-family-portal;
    @include font-small-standart-text;
    letter-spacing: 0px;
    color: $color-primary-company;
  }
  &__delete-word {
    background: none;
    border: none;
    color: #5a607f;
  }
}
</style>
